import { apiClient } from '../lib/client';
import { BRANDING_ENDPOINTS } from './routes';
import type { ApiResponse } from '../lib/types';
import type { BrandingConfig } from './types';

export const getBrandingByDomain = async (domain: string): Promise<ApiResponse<BrandingConfig>> => {
  try {
    const response = await apiClient.get(BRANDING_ENDPOINTS.GET_BY_DOMAIN(domain));
    return { data: response.data };
  } catch (error: any) {
    console.error('Error fetching branding:', error);
    return { error: error.response?.data?.message || 'Unable to load configuration' };
  }
}; 